import { addMask } from 'shared/lib';
import { FIELD_NAMES, sourceAnotherOption, sourceOnlineSchoolOption } from './constants';

export const mainFieldsData = [
  {
    title: 'Персональная информация',
    isTitleNoteVisible: true,
    inputsData: [
      {
        name: FIELD_NAMES.fullname,
        placeholder: 'Введите фамилию и имя*',
        type: 'name',
        max: 60,
      },
      {
        name: FIELD_NAMES.birthday,
        placeholder: 'Введите дату рождения*',
        type: 'date',
      },
      {
        name: FIELD_NAMES.country,
        placeholder: 'Выберите страну проживания*',
        type: 'select',
        options: ['Россия', 'Беларусь'],
      },
      {
        name: FIELD_NAMES.city,
        placeholder: 'Введите город проживания*',
        type: 'input',
        max: 32,
      },
    ],
  },
  {
    title: 'Контактная информация',
    inputsData: [
      {
        name: FIELD_NAMES.phone,
        placeholder: 'Введите номер телефона*',
        type: 'phone',
      },
      {
        name: FIELD_NAMES.email,
        placeholder: 'Введите адрес электронной почты*',
        type: 'email',
        max: 134,
      },
      {
        name: FIELD_NAMES.telegram,
        placeholder: 'Введите имя (как в Телеграме)*',
        type: 'input',
        max: 32,
      },
    ],
    gridContainerProps: { sx: { '& > :last-child': { gridColumn: { xt: 'span 2' } } } },
  },
  {
    title: 'Образование',
    inputsData: [
      {
        name: FIELD_NAMES.education,
        placeholder: 'Опишите образование и годы обучения*',
        type: 'textarea',
        max: 2048,
      },
      {
        name: FIELD_NAMES.englishLevel,
        placeholder: 'Уровень владения английским*',
        type: 'select',
        options: [
          addMask('-', 'Не владею'),
          addMask('Beginner/Elementary (A1)', 'Начальный / Beginner / Elementary (A1)'),
          addMask('Pre-Intermediate (A2)', 'Элементарный / Pre-Intermediate (A2)'),
          addMask('Intermediate (B1)', 'Средний / Intermediate (B1)'),
          addMask('B2', 'Выше среднего / Upper-Intermediate (B2)'),
          addMask('C1', 'Продвинутый / Advanced (C1)'),
        ],
      },
    ],
    gridContainerProps: { templateColumns: '1fr' },
  },
  {
    title: 'Дополнительная информация',
    inputsData: [
      {
        name: FIELD_NAMES.additionalEducation,
        label: 'Опишите доп. образование и навыки*',
        placeholder:
          'Дополнительное образование: курсы и технологии; достижения — олимпиады, конференции, хакатоны',
        type: 'textarea',
        max: 2048,
      },
      {
        name: FIELD_NAMES.informationSource,
        placeholder: 'Как вы узнали об ASTON?*',
        type: 'select',
        options: [
          'Канал в приложении Telegram «ASTON. Курсы и Стажировки»',
          'Поисковая система Google',
          'Поисковая система Яндекс',
          'Реклама в Яндексе',
          'Портал по поиску работы (hh.ru, rabota.by)',
          'Рекомендации знакомых — сотрудников ASTON',
          'Курсы компании ASTON',
          'Профессиональная социальная сеть LinkedIn',
          'Хабр (Карьера / Образование)',
          'Социальная сеть Instagram',
          'Социальная сеть ВКонтакте',
          'Высшее учебное заведение (ВУЗ)',
          sourceOnlineSchoolOption,
          'Реклама в приложении МАКС',
          sourceAnotherOption,
        ],
      },
    ],
    gridContainerProps: { templateColumns: '1fr' },
  },
];

export const sourceFieldsData = {
  source: {
    name: FIELD_NAMES.source,
    placeholder: 'Другой ресурс*',
    type: 'input',
    max: 50,
  },

  sourceOnlineSchool: {
    name: FIELD_NAMES.sourceOnlineSchool,
    placeholder: 'Введите название онлайн-школы*',
    type: 'input',
    max: 50,
  },
};
